var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockWithCross = function SvgLockWithCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88 90",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#D0D7DE",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E7780",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25 37h38v34H25z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E7780",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M41 45h6v10h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F7",
    d: "M47 58h26v18H47z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E7780",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M44 17c6.075 0 11 4.925 11 11v9H33v-9c0-6.075 4.925-11 11-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6E7780",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M44 21a7 7 0 0 1 7 7v9H37v-9a7 7 0 0 1 7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F5F7",
    stroke: "#6E7780",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M68.09 59.038A15.5 15.5 0 0 0 62.5 58C53.94 58 47 64.94 47 73.5S53.94 89 62.5 89 78 82.06 78 73.5c0-1.832-.318-3.59-.901-5.22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C83133",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m57 68 11 11M74.804 61.196 57 79"
  }))));
};
export default SvgLockWithCross;